import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import FormC2bVehicle from '@adv-mt/mt-form-c2b-vehicle'
import Layout from '@adv-mt/mt-layout-basic'

import {useLandingInstantOfferTracking} from '../../../useLandingInstantOfferTracking.js'
import HeaderStep from '../../HeaderStep/index.js'

const BASE_CLASS_NAME = 'mt-Landing-InstantOffer-StepVehicleForm'

const LandingInstantOfferStepVehicleForm = ({makesList, onClickSubmit, origin, sellerVehicle}) => {
  const {domain} = useContext(Context)
  const {pageTrackVehicleFormStep, trackFieldAutocompletion, trackFieldChange, trackSubmitVehicleFormError} =
    useLandingInstantOfferTracking()

  useMount(() => {
    pageTrackVehicleFormStep({origin})
    trackFieldAutocompletion({fields: {...sellerVehicle}})
  })

  const handleSubmitError = ({errors}) => {
    const {formErrorTypes} = domain.get('config').get('form')
    trackSubmitVehicleFormError({errorType: formErrorTypes.fieldError, errors})
  }

  return (
    <Layout.Container isFullWidth>
      <main className={BASE_CLASS_NAME}>
        <HeaderStep
          pretitle={'Véndelo a un profesional'}
          title={'Datos del vehículo'}
          description={`Para poder realizar una tasación inicial necesitamos conocer cuál es tu vehículo y sus características.`}
        />
        <FormC2bVehicle
          initialFieldValues={sellerVehicle}
          makesList={makesList}
          onAutocompleteField={trackFieldAutocompletion}
          onClickSubmit={onClickSubmit}
          onFieldChange={trackFieldChange}
          onSubmitError={handleSubmitError}
        />
      </main>
    </Layout.Container>
  )
}

LandingInstantOfferStepVehicleForm.displayName = 'LandingInstantOfferStepVehicleForm'

LandingInstantOfferStepVehicleForm.propTypes = {
  makesList: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  onClickSubmit: PropTypes.func,
  origin: PropTypes.string.isRequired,
  sellerVehicle: PropTypes.shape({km: PropTypes.string.isRequired, plate: PropTypes.string.isRequired}).isRequired
}

export default LandingInstantOfferStepVehicleForm
